export default __webpack_public_path__ + "static/media/two-icon.61e720bb.svg";